import React from 'react';

const ImageCard = ({ imageSrc, title, description }) => {
  return (
    <div className="relative overflow-hidden rounded-xl shadow-lg group cursor-pointer">
      <img
        src={imageSrc}
        alt={title}
        className="w-full h-64 object-cover transform transition-transform duration-500 group-hover:scale-105"
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col justify-center items-center text-center p-4">
        <h3 className="text-white text-xl font-bold mb-2">{title}</h3>
        <p className="text-white text-sm">{description}</p>
      </div>
    </div>
  );
};

export default ImageCard;
